// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lmj7XKJY1OScWgA5hPgt {
  border: none;
  outline: none;
  padding: 0.5625rem 0.625rem;
  background-color: var(--pdp-business-form-button-background);
  border-radius: 0.625rem;
  cursor: pointer;
}

.xbUePscYpEsiW8WaBn7N {
  cursor: pointer;
  max-width: 100%;
}

.QEfgvAxM9Q7gLXGSbcWW {
  color: var(--white);
}

.qPA8JenFhD89IrIY9wc7 {
  display: flex;
  align-items: center;
}

.dUgN5WQRnJB7YBxMwcqW {
  margin-right: 0.875rem;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .qPA8JenFhD89IrIY9wc7 {
    margin-top: 0.75rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .qPA8JenFhD89IrIY9wc7 {
    margin-top: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BusinessPDPOpenFormSection/BusinessPDPOpenFormSection.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,2BAAiB;EACjB,4DAA4D;EAC5D,uBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAkB;AACpB;;AAEA;;;EACE;IACE,mBAAgB;EAClB;AACF;;AAEA;;EACE;IACE,mBAAgB;EAClB;AACF","sourcesContent":[".button {\n  border: none;\n  outline: none;\n  padding: 9px 10px;\n  background-color: var(--pdp-business-form-button-background);\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.image {\n  cursor: pointer;\n  max-width: 100%;\n}\n\n.buttonText {\n  color: var(--white);\n}\n\n.businessPDPOpenFormSection {\n  display: flex;\n  align-items: center;\n}\n\n.pdpBusinessLogo {\n  margin-right: 14px;\n}\n\n@media (--tablet) {\n  .businessPDPOpenFormSection {\n    margin-top: 12px;\n  }\n}\n\n@media (--mobile) {\n  .businessPDPOpenFormSection {\n    margin-top: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `lmj7XKJY1OScWgA5hPgt`,
	"image": `xbUePscYpEsiW8WaBn7N`,
	"buttonText": `QEfgvAxM9Q7gLXGSbcWW`,
	"businessPDPOpenFormSection": `qPA8JenFhD89IrIY9wc7`,
	"pdpBusinessLogo": `dUgN5WQRnJB7YBxMwcqW`
};
export default ___CSS_LOADER_EXPORT___;
